import React, { useState } from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import Img from "gatsby-image"
import Button from "@material-ui/core/Button"
import Hidden from "@material-ui/core/Hidden"
import Grid from "@material-ui/core/Grid"
import Box from "@material-ui/core/Box"
import styled from "styled-components"
import WrapTypo from "../components/WrapTypo"
import AnimeButton from "../components/AnimeButton"
import containURL from "../components/continueURL"

const WhiteButton = styled(Button)`
  width: 207px;
  height: 45px;
  margin: auto;
  border: 1px solid #6e6e6e;
  text-align: center;
  border-radius: 0;
`

function TopView() {
  const data = useStaticQuery(graphql`
    query {
      sp_top_image: file(relativePath: { eq: "up4_20211115.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 800) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      sp_UNFILTER: file(relativePath: { eq: "sp_UNFILTER.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <>
      <Box width="100%" position="relative" zIndex="-10">
        <Img fluid={data.sp_top_image.childImageSharp.fluid} />
        <Box position="absolute" bottom="0" width="100%">
          <Img fluid={data.sp_UNFILTER.childImageSharp.fluid} />
        </Box>
      </Box>
      <Grid
        container
        direction="column"
        justify="center"
        alignItems="center"
        style={{ backgroundColor: "#ffffff" }}
      >
        <Box padding="33px 0 26px">
          <Box padding="0 0 26px">
            <WrapTypo fs="18px">心と体のフィルターを取り除くと</WrapTypo>
            <WrapTypo fs="18px">私には艶と香りが残ります。</WrapTypo>
          </Box>
          <Box padding="0 0 44px">
            <WrapTypo fs="10px">
              定期的に続けられる集中スキンケアプログラム
            </WrapTypo>
            <WrapTypo fs="10px" lh="200%">
              「UNFILTER Treatment bath oil」
            </WrapTypo>
            <WrapTypo fs="10px" lh="200%">
              贅沢なアロマとプレミアムオイルが心と体のフィルターを取り除き
            </WrapTypo>
            <WrapTypo fs="10px" lh="200%">
              あなた本来の美しい肌へと導きます。
            </WrapTypo>
          </Box>
          <Box margin={"auto"} width="clamp(120px,13vw,250px)">
            <AnimeButton
              href="/product"
              text="詳しく見る"
              width="clamp(140px,13vw,250px)"
              height="clamp(35px,2.5vw,50px)"
              fs="clamp(12px,1.2vw,24px)"
              color="#565656"
              border="solid 1px #565656"
              bgColor="#565656"
              afterColor="#fff"
            />
          </Box>
        </Box>
      </Grid>
    </>
  )
}

function ButtonComponent() {
  return (
    <>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Link to={containURL("")}>
          <WhiteButton>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <WrapTypo fs="14px" color="#6e6e6e">
                詳しく見る
              </WrapTypo>
            </div>
          </WhiteButton>
        </Link>
      </div>
    </>
  )
}

export default TopView
